// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"u1-z","colorTextValue":"v1-z","swatches":"w1-z","collapseLink":"x1-z","isCollapsed":"y1-z","dropdown":"z1-z","disabled":"A1-z"};